import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  DetailedSurvey,
  currentSurveySliceState,
} from "@survey-types/survey.core.types";

// =====================================
// CORE SURVEY STATE MANAGEMENT
// =====================================

export const coreReducers = {
  setCurrentSurvey: (
    state: currentSurveySliceState,
    action: PayloadAction<DetailedSurvey | null>,
  ) => {
    state.currentSurvey = action.payload;
  },

  updateCurrentSurvey: (
    state: currentSurveySliceState,
    action: PayloadAction<Partial<DetailedSurvey>>,
  ) => {
    if (state.currentSurvey) {
      state.currentSurvey = { ...state.currentSurvey, ...action.payload };
    } else {
      // Initialize with full survey data on first load
      state.currentSurvey = action.payload as DetailedSurvey;
    }
  },

  setLoading: (
    state: currentSurveySliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.isLoading = action.payload;
  },

  setError: (
    state: currentSurveySliceState,
    action: PayloadAction<string | null>,
  ) => {
    state.error = action.payload;
  },

  setOpenPropertiesDrawer: (
    state: currentSurveySliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.isPropertiesDrawerOpen = action.payload;
  },

  setOpenPOIsDrawer: (
    state: currentSurveySliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.isPOIsDrawerOpen = action.payload;
  },

  currentPoiId: (
    state: currentSurveySliceState,
    action: PayloadAction<{ poiId: string | null } | null>,
  ) => {
    state.currentPoiId = action.payload ? action.payload.poiId : null;
  },

  setShareModalOpen: (
    state: currentSurveySliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.isShareModalOpen = action.payload;
  },

  setStyleEditInProgress: (
    state: currentSurveySliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.isStyleEditInProgress = action.payload;
  },
};
